import LatestVideos from './LatestVideos';
import React from 'react';

const LatestVideosWithProps = (props: any) => {
  return (
    <LatestVideos
      sectionTitle={props.sectionTitle}
      sectionCtaLabel={props.sectionCtaLabel}
      sectionCtaLink={props.sectionCtaLink}
      videoResourceItems={props.videoResourceItems}
    />
  );
};

export default LatestVideosWithProps;
